import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';
// import { isPermanentSuspensionDate } from '../helpers/suspensionHelper';

export default class PushFrontSuccessedNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-zt-tj.png`;
  }

  href() {
    let post = this.attrs.notification.subject();
    if (!post) {
      return;
    }
    return app.route.post(post);
  }

  content() {
    const notification = this.attrs.notification;
    const title = notification.content().title;
    const userId = notification.content().userId;
    const isFronts = notification.content().isFronts;
    const myObject = notification.content().myObject;
    const isUser = app.session.user.id() == userId;
    return app.translator.trans( `dl_discussion_controller.forum.notices.${isUser ? 'user' : 'banzhu_success'}_text`,
    {title:title,addExp:myObject.addExperience,addIntegra:myObject.addIntegra});

  }
}
